import React from "react";
import { Placeholder } from "semantic-ui-react";

const PlaceholderMultiLine = ({ numberLine = 3 }) => (
  <Placeholder fluid>
    {[...Array(numberLine)].map((v, key) => <Placeholder.Line key={key} />)}
  </Placeholder>
);

export default PlaceholderMultiLine;